export default function () {
  try {
    console.log('Deleting session from localStorage')
    localStorage.removeItem('session')
    return true
  } catch (err) {
    console.log('delete session error:', err)
    return false
  }
}